import {
	type ApplicationKey,
	SOFTWARE,
	SERVICE_DESK,
} from '@atlassian/jira-shared-types/src/application-key.tsx';
import type { ApplicationEdition } from '@atlassian/jira-shared-types/src/edition.tsx';
import type { TenantContext } from '@atlassian/jira-shared-types/src/tenant-context.tsx';

export const getProductEdition = (
	product: ApplicationKey,
	tenantContext: TenantContext,
): ApplicationEdition => {
	if (product === SOFTWARE) {
		return tenantContext.appEditions.software;
	}
	if (product === SERVICE_DESK) {
		return tenantContext.appEditions.serviceDesk;
	}

	return tenantContext.appEditions.core;
};
